<template>

  <v-snackbar :color="$data.$snack.color"
              :bottom="$data.$snack.bottom"
              :top="$data.$snack.top"
              :left="$data.$snack.left"
              :right="$data.$snack.right"
              v-model="snackbar"
              :timeout="$data.$snack.timeout"
              dark>
    <v-icon color="white"
            class="mr-3">
      mdi-bell-plus
    </v-icon>
    <div>{{$data.$snack.error_text}}</div>
    <v-icon size="16"
            @click="snackbar = false">
      mdi-close-circle
    </v-icon>
  </v-snackbar>





</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  //const { mapState, mapMutations } = createNamespacedHelpers('app');

  // Komponenta vuče podatke iz storea...
  // Primjer poziva iz druge komponente (već je registrirano u aplikaciji, pa samo napraviti <SnackMsg ref="snackMsg"></SnackMsg>)
  //this.$refs.snackMsg.snack('top', 'right', { text: this.$t('security.login_error'), color: 'error' })


  export default {
    name: 'SnackMessages',
    computed: {
      //...mapState('app', { snackState: 'snack' })
    },
    
    methods: {
      //...mapMutations('app', { SET_SNACK_PROPS: 'SET_SNACK_PROPS' }),

      snackMe(...args) {
        this.$SET_SNACK_PROPS(args);
        this.snackbar = true
      }

    },
    data: function () {
      return {
        state: null,
        //timeout: 10000,
        // Snack settings
        //error_text: '',
        //color: 'error',
        //colors: [
        //  'purple',
        //  'info',
        //  'success',
        //  'warning',
        //  'error'
        //],
        //top: true,
        //bottom: false,
        //left: false,
        //right: false,
        snackbar: false
      }
    }
  }

</script>



// WEBPACK FOOTER //
// VueSrc/Common/Components/SnackMessages.vue